// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"6e664756","599":"e7c59680","688":"9cc2feff","934":"6527c307"}[chunkId] + ".chunk.js";
};